<div
    [style.display]="isMouseDown && active ? 'block' : 'none'"
    [style.top.px]="rect.top"
    [style.left.px]="rect.left"
    [style.width.px]="rect.width"
    [style.height.px]="rect.height"
></div>
